<template>
  <div>
    <v-sheet
      v-if="!isRHProtegido && !hasMajorityQueryParameters() || !maximize"
      height="80"
      width="100%"
      color="primary"
    />

    <v-container
      fluid
      class="fill-height d-flex align-start"
      style="padding: 10px 35px 0 !important;">
      <v-row>
        <v-col
          cols="12"
          :class="{
            'd-flex pb-1': true,
            'justify-space-between': !isRHProtegido,
            'justify-start': isRHProtegido
          }">
          <span
            span class="base-title">
            PAINEL DE CONTROLE: MAIORIDADE
          </span>

          <v-btn
            v-if="!isRHProtegido && maximize"
            outlined
            style="height: 50px; width: 130px; border-radius: 10px;"
            color="primary"
            @click="openNewTab">
            Maximizar
          </v-btn>
        </v-col>

        <v-tabs
          background-color="transparent"
          color="primary"
          v-model="majorityTabItems"
          style="padding: 0 12px 10px;">
          <v-tab key="majority" href="#majority">
            Maioridade
          </v-tab>

          <v-tab key="reports" href="#reports">
            Meus Relatórios
          </v-tab>
        </v-tabs>

        <v-tabs-items
          class="transparent"
          v-model="majorityTabItems"
          style=" width: 100%;">
          <v-tab-item
            key="majority"
            value="majority"
            class="transparent">
            <v-container
              fluid>
              <v-row>
                <v-col
                  cols="12">
                  <MajorityFilter />
                </v-col>

                <v-col cols="12">
                  <v-row>
                    <v-col
                      cols="12"
                      xl="6"
                      lg="6"
                      md="12"
                      sm="12"
                      :class="{
                        'd-flex justify-start': $vuetify.breakpoint.lgAndUp,
                        'd-flex justify-center pb-1 pt-0': $vuetify.breakpoint.mdAndDown,
                      }">
                      <MajoritySubfilter
                        v-if="showSubFilterComponentView"
                      />
                    </v-col>

                    <v-col
                    cols="12"
                      xl="6"
                      lg="6"
                      md="12"
                      sm="12"
                      :class="{
                        'd-flex justify-end': $vuetify.breakpoint.lgAndUp,
                        'd-flex justify-center py-1': $vuetify.breakpoint.mdAndDown,
                      }">
                      <MajorityActions />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  cols="12">
                  <MajorityTable />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item
            key="reports"
            value="reports">
            <ReportView :tab="majorityTabItems" />
          </v-tab-item>
        </v-tabs-items>
      </v-row>

      <div
        style="padding-top: 12px; padding-bottom: 12px; width: 100%">
        <DefaultFooter
          defaultColor="primary"
          :defaultRoute="defaultRoute"
          :btnStyle="btnFooter.style"
          columnStyle="width: 300px; padding-right: 0px;"
        />
      </div>

      <RequestModal />

      <FullScreenLoader
        v-if="loadPage"
      />

      <SnackbarCustomize
        ref="MajoritySnackbar"
      />

      <ExportReportModal
        :show="showRequestModal"
      />

      <ExportReportConfirmModal
        :show="showConfirmModal"
      />
    </v-container>
  </div>
</template>

<script>
import ExportReportConfirmModal from '@/components/Majority/components/ExportReportConfirmModal.vue';
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import ExportReportModal from '@/components/Majority/components/ExportReportModal.vue';
import FullScreenLoader from '@/components/FullScreenLoader/FullScreenLoader.vue';
import DefaultFooter from '@/components/Default/DefaultFooter/DefaultFooter.vue';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import RequestModal from '@/components/Majority/components/RequestModal.vue';
import MajoritySubfilter from '@/components/Majority/components/majority/MajoritySubfilter.vue';
import MajorityActions from '@/components/Majority/components/majority/MajorityActions.vue';
import MajorityFilter from '@/components/Majority/components/majority/MajorityFilter.vue';
import MajorityTable from '@/components/Majority/components/majority/MajorityTable.vue';
import ReportView from '@/views/majority/majorityReport.vue';

import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import MajorityRules from '@/components/Majority/rules/majorityRules.js';
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';

import { BTN_FOOTER } from '@/components/Majority/constants/viewStyles';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  name: "MajorityView",

  components: {
    ExportReportConfirmModal,
    ExportReportModal,
    MajoritySubfilter,
    SnackbarCustomize,
    FullScreenLoader,
    MajorityActions,
    MajorityFilter,
    DefaultFooter,
    MajorityTable,
    RequestModal,
    ReportView,
  },

  data: () => ({
    defaultRoute: 'HomeAllMenus',
    maximize: false,
    financialGroups: [],
    moment,
    scrollHeight: null,
    majorityScrollHeightObserver: null
  }),

  mixins: [
    InsuranceCarriersMixin,
    GenericFunctionsMixin,
    FinancialGroupsMixin,
    ContractsMixin,
    MajorityRules,
    MajorityMixin,
  ],

  watch: {
    majorityScrollHeightObserver: {
      handler(viewScrollHeight) {
        console.log(
          `%c🟩 scrollHeight: ${viewScrollHeight}px`,
          'color: white; background: success; padding: 4px; border-radius: 4px; font-weight: bold;'
        );
        window.parent.postMessage({ iframeHeight: viewScrollHeight}, '*');
      },
    },
  },

  methods: {
    ...mapActions({
      setMajorityFilter: 'majority/setMajorityFilter',
      fetchMajorities: 'majority/fetchMajorities',
      fetchCoverages: 'majority/fetchCoverages',
    }),

    ...mapMutations({
      resetInsuranceCarriers: 'insurance-carrier/resetModule',
      resetFinancialGroups: 'financial-group/resetModule',
      setPageMounted: 'majority/setPageMounted',
      setMajorityTab: 'majority/setMajorityTab',
      resetContracts: 'contract/resetModule',
      resetMajority: 'majority/resetModule',
      loadingPage: 'majority/loadingPage',

      setInsuranceCarriers: 'insurance-carrier/setInsuranceCarriers',
      setIsRHProtegido: 'user-info/setIsRHProtegido',
      setAppOrigin: 'user-info/setAppOrigin'
    }),

    openNewTab() {
      const url = new URL(window.location.href);
      url.searchParams.set('maximize', 'false');
      window.open(url.toString(), '_blank');
    },

    async fetchQueryParameters() {
      this.maximize = this.$route.query && this.$route.query.hasOwnProperty('maximize')
        ? this.stringToBoolean(this.$route.query.maximize)
        : false;

      if (!this.hasMajorityQueryParameters()) return;

      const majorityQueryKeys = ['competency', 'financialGroupId', 'contractId', 'subContractId', 'externalProtocol'];
      const majorityQueryFilter = Object.fromEntries(
        majorityQueryKeys.map((key) => [key, this.$route.query[key]])
      );

      const competency = moment(majorityQueryFilter.competency, 'YYYY-MM');
      const competenceMonth = parseInt(competency.format('MM'));
      const competenceYear = parseInt(competency.format('YYYY'));
      const financialGroupId = majorityQueryFilter.financialGroupId && parseInt(majorityQueryFilter.financialGroupId);
      const contractId = majorityQueryFilter.contractId && parseInt(majorityQueryFilter.contractId);
      const subContractId = majorityQueryFilter.subContractId && parseInt(majorityQueryFilter.subContractId);
      const externalProtocol = majorityQueryFilter.externalProtocol || null;

      const rawParams = {
        competenceMonth,
        competenceYear,
        financialGroupId,
        contractId,
        subContractId,
        externalProtocol,
      };

      const majorityParameter = Object.entries(rawParams)
        .filter(([_, value]) => value !== null && value !== undefined)
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

      this.setMajorityFilter(majorityParameter);

      if (this.hasMajorityQueryParameters()) {
        if (financialGroupId) {
          await this.getContractsByFinancialGroupIdVerifyRhProtegido(financialGroupId, this.isRHProtegido);
        }

        if (contractId) {
          await this.getSubContractsByContractId(contractId);
        }
      }
    },
  },

  computed: {
    ...mapGetters({
      showConfirmModal: 'majority/showConfirmModal',
      showRequestModal: 'majority/showRequestModal',
      fGroups: 'financial-group/groups',
      majorityTab: 'majority/majorityTab',
      appOrigin: 'user-info/appOrigin',
      loadPage: 'majority/loadPage',
    }),

    majorityTabItems: {
      get() {
        return this.majorityTab;
      },

      set(value) {
        this.setMajorityTab(value);
      }
    },

    btnFooter() {
      return BTN_FOOTER;
    },

    showSubFilterComponentView() {
      return this.showSubFilterComponent;
    }
  },

  async created() {
    const isRHProtegido = this.$route.query.isRHProtegido
      ? this.stringToBoolean(this.$route.query.isRHProtegido.toString())
      : this.appOrigin && this.appOrigin !== 'BACKOFFICE';

    this.defaultRoute = 'HomeAllMenus';

    if (isRHProtegido) {
      this.defaultRoute = 'HomeRHProtegidoServicos';
    }

    this.setIsRHProtegido(isRHProtegido);
    this.setAppOrigin(isRHProtegido ? 'PROTECTED_HR' : 'BACKOFFICE');

    this.loadingPage(true);

    try {
      await Promise.all([
        this.getInsuranceCarriers(),
        this.getFinancialGroups(),
        this.fetchCoverages(),
      ]);

      await this.fetchQueryParameters();

      setTimeout(async () => {
        await this.fetchMajorities();
      }, 500);
    } catch(error) {
      this.$refs.MajoritySnackbar.open(
        'error',
        'Ocorreu um erro ao carregar os dados da página'
      )
    } finally {
      this.loadingPage(false);

      this.setPageMounted(true);
    }
  },

  mounted() {
    if (this.fGroups && this.fGroups.length === 1) {
      this.setMajorityFilter({
        financialGroupId: this.fGroups[0].id
      })
    }

    this.resizeObserver = new ResizeObserver(() => {
      this.majorityScrollHeightObserver = document.body.scrollHeight;
    });
    this.resizeObserver.observe(document.body);
  },

  beforeDestroy() {
    this.resetInsuranceCarriers();
    this.resetFinancialGroups();
    this.resetContracts();
    this.resetMajority();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
}
</script>